export default "__VITE_ASSET__CSQZ85bZ__"